import React, { useRef, useLayoutEffect } from "react";

const TextInput = ({
  name,
  id = "",
  label,
  value,
  handleChange,
  placeholder = "",
  required = false,
  disabled = false,
  errorMessage = {},
  type = "text",
  maxLength,
  cName,
  autoComplete = "off",
  readonly = false,
  handleBlur,
  parentClassName,
  labelClassName,
  onKeyDown,
  inputRef,
}) => {
  // const inputRef = useRef(null);
  const caretPosRef = useRef(0);

  // Store caret position before React rerenders
  const handleInputChange = (e) => {
    caretPosRef.current = e.target.selectionStart;
    handleChange(e); // Pass full event to parent
  };

  // Restore caret position after re-render
  // useLayoutEffect(() => {
  //   if (inputRef.current && document.activeElement === inputRef.current) {
  //     inputRef.current.setSelectionRange(
  //       caretPosRef.current,
  //       caretPosRef.current
  //     );
  //   }
  // }, [value]);

  return (
    <div className={parentClassName + " mb-3"}>
      {label && (
        // <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
        <label
          className={`form-label w-100 form-label-custom-visible ${labelClassName}`}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <>
        <input
          ref={inputRef}
          type={type}
          className={`fw-normal form-control fs-5 ${cName} ${
            errorMessage[name]?.trim()?.length > 0 ? "input-error" : ""
          }`}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={handleInputChange} // ✅ use custom handler
          onBlur={handleBlur}
          // required={required}
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
          readOnly={readonly}
          onKeyDown={onKeyDown}
          // onPaste={(e) => {
          //   console.log("PASTE EVENT", e.clipboardData.getData("text"));
          // }}
        />
      </>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
};

export default TextInput;
